import React from 'react';
import {Icon } from 'antd';

const Remove = ({service, callback = () => {}, title, setLoading}) => (
    <a href="javascript:;" className="delete" onClick={() => {
        service.batchRemove(callback, setLoading);
    }}><Icon type="delete" />{title || "删 除"}</a>
);

export default Remove;